import { getLovemoSiteOrigin, getLovemoSocialImage } from "@/seo/lovemoSeo";

export interface LovemoJsonLd {
  "@context": string;
  "@type": string;
  [key: string]: unknown;
}

export function buildLovemoSoftwareApplicationSchema(): LovemoJsonLd {
  const origin = getLovemoSiteOrigin();
  return {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    name: "Lovemo",
    applicationCategory: "LifestyleApplication",
    operatingSystem: "Android, iOS, HarmonyOS, Windows",
    url: `${origin}/`,
    image: getLovemoSocialImage(),
    description:
      "Lovemo 是一款懂情绪的AI陪伴聊天工具，支持 Android、iOS、HarmonyOS、Windows 全平台，提供官方正版免费下载与下载教程。",
    inLanguage: "zh-CN",
    offers: {
      "@type": "Offer",
      price: "0",
      priceCurrency: "CNY",
    },
  };
}

export function buildLovemoJsonLd(kind: "software" | null): LovemoJsonLd | null {
  if (kind === "software") return buildLovemoSoftwareApplicationSchema();
  return null;
}